import * as React from "react";
import {translate} from "react-i18next";

// reducer
import {ITranslatedComponent} from "../../../redux/reducers/generalReducer";

// semantic
import {Modal, Segment} from "semantic-ui-react";

import {renderErrorToast} from "../../../utils/FeedbackMessageUtils";

export interface IDetailsDialogProps extends ITranslatedComponent {
    /** Header text of the dialog. */
    headerText?: string;

    /** Call back to request specific details object. */
    onRequestDetails: () => Promise<any>;

    /** Render prop for the specific details type. */
    onRender: (details?: any) => JSX.Element;

    /** Callback when the user closes the dialog. */
    onClose: () => void;
}

interface IDetailsDialogState {
    /** Whether or not we are waiting for a response from the back end. */
    loading: boolean;

    /** The details received from the back end. */
    details?: any;
}

/**
 * DetailsDialog is a modal dialog to display the detail information
 * of an element in the admin view. It's used inside the Users and Groups
 * view, see implementation for UserDetailsDialog and GroupDetailsDialog.
 *
 * The detail information specific to the element type (user or group) are
 * requested from the back end using the onRequestDetails() prop.
 * The dialog handles the loading indicator (when waiting for the back end
 * request to return) and errors.
 */
export class DetailsDialog extends React.Component<IDetailsDialogProps, IDetailsDialogState> {
    constructor(props: IDetailsDialogProps) {
        super(props);

        this.state = {
            loading: false,
            details: undefined,
        };
    }

    componentDidMount() {
        this.requestDetails();
    }

    requestDetails = (): void => {
        this.setState({loading: true});

        this.props.onRequestDetails()
            .then((response: any) => {
                this.setState({loading: false, details: response});
            })
            .catch((reason: any) => {
                renderErrorToast(
                    {
                        message: "ERRORS:REQUEST_DETAILS_FAILED",
                        details: reason,
                        timestamp: Date.now(),
                    }
                );

                this.setState({loading: false}, this.props.onClose);
            });
    }

    renderDetails = (loading: boolean, details?: any): JSX.Element => (
        <Segment
            loading={loading}
            content={this.props.onRender(details)}
        />
    )

    render() {
        return (
            <Modal
                open={true}
                closeIcon={true}
                onClose={() => this.props.onClose && this.props.onClose()}
            >
                {
                    this.props.headerText &&
                    <Modal.Header>{this.props.headerText}</Modal.Header>
                }
                <Modal.Content style={{padding: '0'}}>
                    {this.renderDetails(this.state.loading, this.state.details)}
                </Modal.Content>
            </Modal>
        );
    }
}

export default translate("ADMIN_VIEW")(DetailsDialog);



// WEBPACK FOOTER //
// ./src/views/AdminView/AccessTab/DetailsDialog.tsx